import React from "react";
import PropTypes from "prop-types";
import { Route, Redirect, withRouter } from "react-router-dom";

import Helper from "util/Helper";

class ProtectedRoute extends React.Component {
  constructor() {
    super();

    this.helper = new Helper();
  }

  render() {
    if (this.props.authenticator()) {
      return <Route exact {...this.props} />;
    } else {
      return <Redirect to={this.props.redirectTo} />;
    }
  }
}

ProtectedRoute.propTypes = {
  path: PropTypes.string.isRequired,
  // Either `component` or `render` — passing `render` lets a route key its
  // element so it remounts on a param change (a fresh load, not a re-run).
  component: PropTypes.func,
  render: PropTypes.func,
  authenticator: PropTypes.func.isRequired,
  redirectTo: PropTypes.string.isRequired,
};

export default withRouter(ProtectedRoute);
